import { loginWithEmailPassword, logout } from '~/firebase/auth';

export const constants = {
  INIT: 'AUTH:INIT',
  LOGIN: {
    SUCCESS: 'AUTH:LOGIN:SUCCESS',
    ERROR: 'AUTH:LOGIN:ERROR'
  },
  LOGOUT: {
    SUCCESS: 'AUTH:LOGOUT:SUCCESS'
  },
  CURRENT_BREWERY: {
    CHANGE: 'AUTH:CURRENT_BREWERY:CHANGE'
  }
};

export const initialState = {
  uid: null,
  initialized: false,
  loggedIn: false,
  error: null
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.INIT:
      return {
        ...state,
        initialized: true
      };
    case constants.LOGIN.SUCCESS:
      return {
        ...state,
        uid: action.payload.uid,
        profile: action.payload,
        loggedIn: true,
        error: null
      };
    case constants.LOGIN.ERROR:
      return {
        ...state,
        loggedIn: false,
        error: action.payload
      };
    case constants.LOGOUT.SUCCESS:
      return {
        ...state,
        uid: null,
        loggedIn: false
      };
    default:
      return state;
  }
}

export const actions = {
  authInitialized: user => {
    return dispatch => {
      dispatch({
        type: constants.INIT
      });

      if (user) {
        dispatch(actions.logIn(user));
      }
    };
  },
  loginWithEmailPassword: (email, password) => {
    return async dispatch => {
      const user = await loginWithEmailPassword(email, password);
      dispatch(actions.logIn(user));
    };
  },
  logIn: user => {
    // User has both user details and breweries. Dispatch both
    return dispatch => {
      dispatch({
        type: constants.LOGIN.SUCCESS,
        payload: user
      });
    };
  },
  logout: () => {
    logout();
    return dispatch => {
      dispatch({
        type: constants.LOGOUT.SUCCESS
      });
    };
  }
};



// WEBPACK FOOTER //
// ./src/redux/auth.js